import { React, connect, PT } from '@gasbuddy/react';
import { Button, Modal, Dropdown, Message } from 'semantic-ui-react';
import { BrandDropDown } from '..';

const brandingTypes = [
  { key: 'fuel', text: 'fuel', value: 'fuel' },
  { key: 'cstore', text: 'cstore', value: 'cstore' },
];

class PoiBrand extends React.Component {
  state ={
    brandId: 0,
    brandingType: '',
    errorMessage: '',
    clicked: false,
  }

  componentWillReceiveProps(nextProps) {
    const { clicked } = this.state;
    if (nextProps.finished && clicked) {
      this.hide();
    }
  }

  brandChange(e, data) {
    this.setState({ brandId: data.value });
  }

  brandTypeChange(e, data) {
    this.setState({ brandingType: data.value });
  }

  addPoiBrand() {
    const { brandId, fuelType, brandingType } = this.state;
    const { successCallback } = this.props;
    const poiBrand = {};
    if (brandId > 0) {
      poiBrand.brand_id = brandId;
    } else {
      this.setState({ errorMessage: 'Valid Brand must be selected' });
    }
    if (fuelType !== '') {
      poiBrand.branding_type = brandingType;
    } else {
      this.setState({ errorMessage: 'Valid fuel type must be selected' });
    }
    if (poiBrand.brand_id && poiBrand.branding_type) {
      this.setState({ clicked: true });
      successCallback(poiBrand);
    }
  }

  show() {
    this.setState({ showModal: true });
    this.setState({ clicked: false });
    this.props.finished = false;
  }

  hide() {
    this.setState({ showModal: false });
  }

  render() {
    const { showModal, clicked, errorMessage } = this.state;
    return (
      <div>
        <Button primary onClick={() => this.show()}>Add Brand</Button>
        <Modal open={showModal}>
          <Modal.Header>Select Brand and Type</Modal.Header>
          <Modal.Content>
            <Dropdown options={brandingTypes} placeholder="Select type" onChange={(e, data) => this.brandTypeChange(e, data)} />
            <BrandDropDown brandChange={(e, data) => this.brandChange(e, data)} />
            {errorMessage !== ''
            && (
            <Message negative>
              {errorMessage}
              {' '}
            </Message>
            )
            }
          </Modal.Content>
          <Modal.Actions>
            <Button
              positive
              onClick={() => this.addPoiBrand()}
              loading={clicked}
            >
OK
            </Button>
            <Button onClick={() => this.hide()}>Cancel</Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

PoiBrand.defaultProps = {
  finished: false,
};

PoiBrand.propTypes = {
  successCallback: PT.func.isRequired,
  finished: PT.bool,
};

export const PoiBrandAdd = connect(state => state)(PoiBrand);
